<template>
  <div class="row mt-10">
    <div
      v-if="freetTextQuestionsAndCategories.length === 0"
      class="col alert alert-info text-info d-flex align-items-center"
    >
      <i class="bi bi-info-circle-fill fs-3 text-info me-3"></i>
      <span>
        {{ $t('freetext.noFreeTextQuestions') }}
      </span>
    </div>

    <div
      v-for="cat in freetTextQuestionsAndCategories"
      :key="cat.name"
      class="col-4 mb-5 mt-3"
    >
      <div class="card h-100">
        <div class="card-header d-flex align-items-center">
          <div class="widget-header-navigation card-title mx-auto">
            <h4 ref="title" class="card-title m-0 px-3">
              {{ $tr(cat.details.messages, 'title') }}
            </h4>
          </div>
        </div>

        <div v-for="q in cat.questions" :key="q.name" class="card-body mb-3">
          <h6 class="">
            {{ $tr(q.details.messages, 'title') }}
          </h6>
          <div class="">
            <div
              v-if="
                responsesForQuestions[q.name] &&
                responsesForQuestions[q.name].answers
              "
            >
              <PulsListGroup
                wrapper-class="free-text-widget mb-5"
                title-class="freetextresponse"
                :items="
                  responsesForQuestions[q.name].answers.map((a, i) => ({
                    key: i,
                    title: a.value,
                    text: a.date.split('T')[0]
                  }))
                "
              />
              <span>
                {{
                  $t(
                    'freetext.responses',
                    responsesForQuestions[q.name].answers.length
                  )
                }}
              </span>
            </div>

            <div
              v-else-if="
                responsesForQuestions[q.name] &&
                responsesForQuestions[q.name].error
              "
              class="freetext-error-wrapper"
            >
              <span
                v-if="
                  responsesForQuestions[q.name].error.code ===
                  'NOT_ENOUGH_RESPONSES'
                "
                class="text-info"
              >
                {{ $t('freetext.notEnoughResponses') }}
              </span>
              <span v-else class="text-danger">
                {{
                  responsesForQuestions[q.name].error.message ||
                  responsesForQuestions[q.name].error
                }}
              </span>
            </div>

            <div v-else>
              <div v-if="loading && loading === q.name">
                <LoadingSpinner />
              </div>
              <div v-else class="loading-placeholder" />
              <button
                class="btn btn-sm btn-secondary"
                :disabled="loading"
                @click="loadResponsesForQuestion(q)"
              >
                {{ $t('freetext.loadResponses') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useExportStore } from '@/stores/export-store'
import { useUserStore } from '@/stores/user-store'
import { useResultsStore } from '@/stores/results-store'
import { useStatesStore } from '@/stores/states-store'
import { requestTypes } from '@/constants/request-types.js'

export default {
  name: 'FreetextVisualizer',
  components: {},
  props: {
    selectedGroup: {
      type: Object,
      default: () => {}
    },
    selectedAttributeSegment: {
      type: Object,
      default: () => {}
    },
    surveyName: {
      type: String,
      default: ''
    },
    surveyDetails: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    const exportStore = useExportStore()
    const userStore = useUserStore()
    const resultsStore = useResultsStore()
    const statesStore = useStatesStore()
    return {
      exportStore,
      userStore,
      resultsStore,
      statesStore
    }
  },

  computed: {
    responsesForQuestions() {
      return this.resultsStore.questions
    },
    surveyIsAggregate() {
      return this.statesStore.surveyIsAggregate
    },
    freetTextQuestionsAndCategories() {
      return this.surveyDetails.details.categories.reduce((categories, c) => {
        // do not filter categories for aggregates
        if (!this.surveyIsAggregate || c.details.enabled) {
          const cat = { ...c, questions: [] }
          c.questions.forEach((q) => {
            if (q.details.type === 'freetext') {
              cat.questions.push({ ...q, categoryName: c.name })
            }
          })
          if (cat.questions.length > 0) {
            categories.push(cat)
          }
        }
        return categories
      }, [])
    },
    loading() {
      return this.resultsStore.loading[requestTypes.QUESTION_RESULTS_FOR_SURVEY]
    }
  },
  watch: {
    selectedGroup() {
      this.responsesLoaded = {}
    },
    selectedAttributeSegment() {
      this.responsesLoaded = {}
    }
  },
  mounted() {},
  methods: {
    responsesForQuestion(question) {
      return this.resultsStore.questions[question.name]
    },
    loadResponsesForQuestion(question) {
      const params = {
        surveyName: this.surveyName,
        groupName: this.selectedGroup.name,
        categoryName: question.categoryName,
        questionName: question.name,
        aggregate: this.surveyDetails.details.aggregate
      }
      if (this.selectedAttributeSegment.name !== 'all') {
        params.selectedAttributeSegment = this.selectedAttributeSegment
      }
      this.resultsStore.loadQuestionResponsesForSurveyAction(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-placeholder {
  height: 26px;
}
.freetext-error-wrapper {
  display: block;
  padding: 10px 15px !important;
  background: var(--kt-info-light) !important;
  border-radius: 15px !important;
  margin-bottom: 10px !important;
  margin-top: 10px !important;
  border: none !important;
}
.answer {
  /* post-it like appearance, yellowish background, rounded corners, padding */
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 0.25rem;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  /* shadow for a bit of depth */
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  /* text color */
  color: #312605;
  /* text alignment */
  text-align: left;
  /* text size */
  font-size: 0.875rem;
  /* text line height */
  line-height: 1.5;
  /* text font */
  font-family: 'Open Sans', sans-serif;
}
</style>
